import {Component, Host, h, Prop, State, Event, EventEmitter, Element, Watch} from "@stencil/core";


@Component({
  tag: 'snap-auth-input',
  styleUrl: 'snap-auth-input.scss',
})
export class SnapAuthInput {
  @Prop({ reflect: true }) error: boolean = false
  @Prop({ reflect: true }) success: boolean = false
  @Prop({ reflect: true }) disabled: boolean = false
  @Prop({ reflect: true }) locked: boolean = false
  @Prop({ reflect: true }) label: string = "Password Code"
  @Prop({ reflect: true }) labelCorner: string = "Required"
  @Prop({ reflect: true }) labelHelperText: string = "Please enter your 6-digit password code."
  @Prop({ reflect: true }) value: string = ""
  @Prop({ reflect: true }) required: boolean = false
  @Prop({ reflect: true }) errorDescription: string = ''

  @State() localValue: Record<number, string> = {}
  @State() hasSlot: boolean = false

  @Element() private element: HTMLElement

  @Event({ eventName: 'snap-auth-input-update', bubbles: true, composed: true }) snapAuthInputUpdate: EventEmitter<string>

  FIELD_COUNT = 6

  private oneTimeCode = ""

  @Watch('value')
  onValueUpdate() {
    if (this.value.trim()) {
      for (let i = 0; i < this.FIELD_COUNT; i ++) {
        this.localValue[i] = this.value.trim()[i]
      }
    }
  }

  componentWillLoad() {
    if (Array.from(this.element.children).length) {
      this.hasSlot = true
    }

   this.onValueUpdate()
  }

  getClasses() {
    const classes = ['snap-auth-input-container']

    this.error ? classes.push('error') : null
    this.disabled ? classes.push('disabled') : null
    this.locked ? classes.push('locked') : null
    this.success ? classes.push('success') : null

    return classes.join(' ').toString()
  }

  onInputHandler(e, index) {
    if (e.target.value.length === 2) {
      e.target.value = e.target.value.replace(/\D/g, '');
      return
    }

    if (!e.inputType) {
      this.oneTimeCode += e.target.value
      if (this.oneTimeCode.length === 6) {
        this.value = this.oneTimeCode
      }
    }
    else if (e.target.value.length === 6) {
      this.value = e.target.value
    }
    else if (e.data === null) {
      return
    }


    const reg =  /^\d+$/;
    if(!reg.test(e.target.value)){
      e.target.value = ""
      return
    }

    // check if we past OTP from chrome/firefox (length 6 means it was chrome or firefox)
    if (e.target.value.length === 6) {
      for (let i = 0; i < e.target.value.length; i++) {
        this.localValue[i] = e.target.value[i]
      }
    }
    else {
      this.localValue[index] = e.target.value;
    }

    e.target.nextElementSibling?.focus()
    this.snapAuthInputUpdate.emit(Object.values(this.localValue).join(""))
  }

  onDeleteHandler(e, index) {
    if ((e.keyCode >= 48 && e.keyCode <= 57)) {
      if (this.localValue[index]) {
        this.localValue[index] = e.key
        e.target.value = e.key
        e.target.nextElementSibling?.focus()
      }
    }

    if (e.key !== 'Backspace') return

    const current = e.target;
    const previous = current.previousElementSibling;
    this.localValue[index] = ""

    if (current.value === "" && previous) {
      previous.focus();
    }
    this.snapAuthInputUpdate.emit(Object.values(this.localValue).join(""))
  }

  onPasteHandler(e) {
    this.setValue(e.clipboardData?.getData("text"));
    this.snapAuthInputUpdate.emit(Object.values(this.localValue).join(""))
  }

  setValue(value = "") {
    this.localValue = {}
    for (let index = 0; index < this.FIELD_COUNT; index++) {
      this.localValue[index] = value.charAt(index) || ""
    }
  }

  render() {
    return (
      <Host>
        <div class="snap-auth-input-label-container">
          <label class="snap-auth-input-label">
            {this.label}
            { this.required && <span class="required">*</span> }
          </label>
          <label class="snap-auth-input-label-corner">{this.labelCorner}</label>
        </div>
        <div class={this.getClasses()}>
          {[...Array(this.FIELD_COUNT)].map((_el, index) => (
              <input class="snap-auth-input"
                     disabled={this.disabled || this.locked}
                     pattern="\d*"
                     inputMode="numeric"
                     autoComplete="one-time-code"
                     maxlength="6"
                     value={this.localValue[index]}
                     onInput={(e) => this.onInputHandler(e, index)}
                     onKeyUp={(e) => this.onDeleteHandler(e, index)}
                     onPaste={(e) => this.onPasteHandler(e)}/>
            )
          )}
          {this.error &&
            <snap-icon class="snap-auth-input-error" icon="exclamation-circle-solid" color="#ef4444" size="sm"></snap-icon>
          }
          {this.success &&
            <snap-icon class="snap-auth-input-success" icon="check-circle-solid" color="#10B981" size="sm"></snap-icon>
          }
          {this.locked &&
            <snap-icon class="snap-auth-input-locked" icon="lock-closed-solid" color="#94A3B8" size="sm"></snap-icon>
          }
        </div>
        {this.error && this.errorDescription
          ? <label class="snap-auth-input-label-text error">{this.errorDescription}</label>
          : <label class="snap-auth-input-label-text helper">{this.labelHelperText}</label>
        }

        {this.hasSlot &&
          <div class="snap-auth-input-label-helper-link">
            <slot />
          </div>
        }
      </Host>
    );
  }
}
